import React, { useContext } from 'react';
import { CashoutConfigurationContext } from '../data/cashout/CashoutConfigurationCtx';
import { ReactComponent as CashoutIcon } from '../icons/tag_cashout_info.svg';
import { getLabel } from '../InitData';

export default function CashoutLabel(props) {
    const cashoutConf = useContext(CashoutConfigurationContext);
    const bet = props.bet;

    if (bet.id === 65520) {
        return <span className="new-market-label">{getLabel('new_market_label', 'New')}</span>;
    }
    
    let cashoutEnabled = false;
    const matchData = bet.odds[0]?.matchData ?? null;
    if (matchData != null) {
        cashoutEnabled = cashoutConf.isCashoutEnabledForSelection(matchData.sportRef,
                                                                  matchData.tournamentRef,
                                                                  matchData.pal,
                                                                  matchData.avv,
                                                                  bet.cs,
                                                                  bet.h,
                                                                  matchData.isLive);
    }
    
    if (!cashoutEnabled) {
        return null;
    }

    return (
        <CashoutIcon />
    );
}
